import * as React from 'react'

import { Alert, Box, Link, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const CreateLeaveLink = () => {
  const { navigation } = useNavigation()

  return (
    <Alert>
      <Box flexDirection="column">
        <Text.Normal>{i18n.t('common.leave_type_all_used')}</Text.Normal>
        <Link.Router to={navigation.settings.timeoffPolicies.newLeaveType.fullPath()}>
          {i18n.t('common.create_leave_type')}
        </Link.Router>
      </Box>
    </Alert>
  )
}

export default CreateLeaveLink
